module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', {
    staticClass: "breadcrumb"
  }, [_vm._v("MANAGE TRIP")]), _vm._v(" "), _c('el-row', {
    staticClass: "row-bg p-10 mt-10 bg-lightgarg",
    attrs: {
      "type": "flex",
      "justify": "space-between"
    }
  }, [_c('el-col', {
    staticClass: "text-right",
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "grid-content"
  }, [_c('el-button', {
    attrs: {
      "type": "success",
      "icon": "el-icon-plus"
    },
    on: {
      "click": function($event) {
        _vm.CreatTripdialog = true
      }
    }
  }, [_vm._v("New Trip")])], 1)])], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "mt-20",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "empty-text": "No data",
      "element-loading-text": "loading...",
      "data": _vm.TripData,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "Name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "saEditEnabled",
      "label": "SA Edit Enabled",
      "width": "180",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-switch', {
          attrs: {
            "active-color": "#13ce66",
            "inactive-color": "#ff4949"
          },
          on: {
            "change": function($event) {
              return _vm.editSaEnable(scope.row)
            }
          },
          model: {
            value: (scope.row.saEditEnabled),
            callback: function($$v) {
              _vm.$set(scope.row, "saEditEnabled", $$v)
            },
            expression: "scope.row.saEditEnabled"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "taEditEnabled",
      "label": "TA Edit Enabled",
      "width": "180",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-switch', {
          attrs: {
            "active-color": "#13ce66",
            "inactive-color": "#ff4949"
          },
          on: {
            "change": function($event) {
              return _vm.editTaEnable(scope.row)
            }
          },
          model: {
            value: (scope.row.taEditEnabled),
            callback: function($$v) {
              _vm.$set(scope.row, "taEditEnabled", $$v)
            },
            expression: "scope.row.taEditEnabled"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "student",
      "label": "Student Edit Enabled",
      "width": "180",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-switch', {
          attrs: {
            "active-color": "#13ce66",
            "inactive-color": "#ff4949"
          },
          on: {
            "change": function($event) {
              return _vm.editStudentEnable(scope.row)
            }
          },
          model: {
            value: (scope.row.studentEditEnabled),
            callback: function($$v) {
              _vm.$set(scope.row, "studentEditEnabled", $$v)
            },
            expression: "scope.row.studentEditEnabled"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "action",
      "label": "Actions",
      "width": "130",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "mini",
            "icon": "el-icon-edit"
          },
          on: {
            "click": function($event) {
              return _vm.EditTrip(scope.row)
            }
          }
        }), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "danger",
            "size": "mini",
            "icon": "el-icon-delete"
          },
          on: {
            "click": function($event) {
              return _vm.DeleteTrip(scope.row)
            }
          }
        })]
      }
    }])
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Create Trip",
      "visible": _vm.CreatTripdialog,
      "customClass": "dialogStyle"
    },
    on: {
      "update:visible": function($event) {
        _vm.CreatTripdialog = $event
      }
    }
  }, [_c('el-form', {
    ref: "Newform",
    attrs: {
      "model": _vm.Newform,
      "rules": _vm.newrules
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Trip Name",
      "prop": "NewName",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('div', {
    staticClass: "el-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Newform.NewName),
      expression: "Newform.NewName"
    }],
    staticClass: "el-input__inner",
    attrs: {
      "placeholder": "Trip Name",
      "auto-complete": "off"
    },
    domProps: {
      "value": (_vm.Newform.NewName)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.NewTrip('Newform')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Newform, "NewName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Trip Tips",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.Newform.tips),
      callback: function($$v) {
        _vm.$set(_vm.Newform, "tips", $$v)
      },
      expression: "Newform.tips"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "period of Tips",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "format": "yyyy-MM-dd",
      "value-format": "yyyy-MM-dd",
      "range-separator": "to",
      "start-placeholder": "start",
      "end-placeholder": "end",
      "picker-options": _vm.endPickerOptions0
    },
    model: {
      value: (_vm.Newform.date),
      callback: function($$v) {
        _vm.$set(_vm.Newform, "date", $$v)
      },
      expression: "Newform.date"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.CreatTripdialog = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.saving
    },
    on: {
      "click": function($event) {
        return _vm.NewTrip('Newform')
      }
    }
  }, [_vm._v("Save")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Edit Trip",
      "visible": _vm.EditTripdialog,
      "customClass": "dialogStyle"
    },
    on: {
      "update:visible": function($event) {
        _vm.EditTripdialog = $event
      }
    }
  }, [_c('el-form', {
    ref: "Editform",
    attrs: {
      "model": _vm.Editform,
      "rules": _vm.editrules
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Trip Name",
      "prop": "EditName",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    attrs: {
      "prop": "EditName",
      "placeholder": "Trip Name",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.Editform.EditName),
      callback: function($$v) {
        _vm.$set(_vm.Editform, "EditName", $$v)
      },
      expression: "Editform.EditName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Trip Tips",
      "prop": "tips",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.Editform.tips),
      callback: function($$v) {
        _vm.$set(_vm.Editform, "tips", $$v)
      },
      expression: "Editform.tips"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "period of Tips",
      "prop": "date",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "format": "yyyy-MM-dd",
      "value-format": "yyyy-MM-dd",
      "range-separator": "to",
      "start-placeholder": "start",
      "end-placeholder": "end",
      "picker-options": _vm.endPickerOptions0
    },
    model: {
      value: (_vm.Editform.date),
      callback: function($$v) {
        _vm.$set(_vm.Editform, "date", $$v)
      },
      expression: "Editform.date"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.EditTripdialog = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.saving
    },
    on: {
      "click": function($event) {
        return _vm.submitedit('Editform')
      }
    }
  }, [_vm._v("Save")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "text-center mt-20 mb-50"
  }, [_c('el-pagination', {
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.size,
      "current-page": _vm.currentPage,
      "page-count": _vm.totalPages
    },
    on: {
      "current-change": _vm.pageCurrentChange
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7ffe1f52"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/admin/Trip.vue
// module id = 620
// module chunks = 1